import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Caution from "../../components/caution";
import EMTLevel from "../../components/emtLevel";
import MyLink from "../../components/myLink";
import StrokeCard from "../../components/stroke";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Caution id="caution-1" mdxType="Caution">
  Say “Stroke Alert” in Hospital Entry Note if patient meets the Stroke Criteria,
  even if symptoms have resolved.
    </Caution>
    <EMTLevel level="basic" mdxType="EMTLevel">
  <EMTLevel level="advanced" mdxType="EMTLevel">
    <EMTLevel level="paramedic" mdxType="EMTLevel">
      <ul>
        <li>
          <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">
            1.0 Routine Patient Care
          </MyLink>
        </li>
        <li>Perform FAST-ED Stroke Scale.</li>
        <li>Clearly determine last time known well.</li>
        <li>
          If the patient wakes from sleep or is found with symptoms of stroke, the time
          is defined as the last time the patient was observed to be normal. Notify the
          emergency department as soon as possible.
        </li>
        <li>
          If any one of the signs of the stroke scale is abnormal and onset of
          symptoms are less than 5 hours, notify receiving hospital of a “Stroke Alert”.
        </li>
        <li>
          Elevate the head of the stretcher 30 degrees.
        </li>
        <li>
          Do not delay transport for ALS intercept.
        </li>
        <li>
          Consider transporting a witness, family member, or caregiver with the patient
          to verify the time of the onset of stroke symptoms.
        </li>
        <li>
          If the onset of signs and symptoms PLUS transport time is &lt; 5 hours,
          consider transport to the most appropriate facility in accordance with local
          guidelines/agreements.
        </li>
        <li>
          Transport to a Department approved Stroke Point-of-Entry (POE) hospital.
        </li>
      </ul>
    </EMTLevel>
  </EMTLevel>
    </EMTLevel>
    <Caution id="caution-2" mdxType="Caution">
  Avoid hyperoxygenation; oxygen administration should be titrated to patient condition,
  and withheld unless evidence of hypoxemia, dyspnea, or an SpO2 &lt;94%, especially in
  the presence of a suspected CVA/TIA or ACS.
    </Caution>
    <StrokeCard mdxType="StrokeCard" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      